"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _form = require("@sharingapples/form");

var _Error = _interopRequireDefault(require("./Error"));

function InputWithError(props, ref) {
  var Type = props.Type,
      name = props.name,
      _props$validator = props.validator,
      validator = _props$validator === void 0 ? function () {} : _props$validator,
      _props$check = props.check,
      check = _props$check === void 0 ? false : _props$check,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? true : _props$wrap,
      _props$parentError = props.parentError,
      parentError = _props$parentError === void 0 ? null : _props$parentError,
      rest = (0, _objectWithoutProperties2["default"])(props, ["Type", "name", "validator", "check", "wrap", "parentError"]); // if check is true, then you can access the form state for validation purposes.
  // this is extremely helpful when you need to validate a particular input with respect to other inputs in the form.
  // For eg: CheckInDate and CheckOut Date in SearchGuideForm.
  // In that case, we have to check that CheckInDate cannot possibly be greater than CheckoutDate or vice-versa.

  var error = (0, _form.useFormValidator)(check ? function (state) {
    return state;
  } : name, Array.isArray(validator) ? _form.pipe.apply(void 0, (0, _toConsumableArray2["default"])(validator)) : validator);

  var body = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(Type, (0, _extends2["default"])({
    name: name,
    ref: ref
  }, rest)), _react["default"].createElement(_Error["default"], {
    error: parentError || error
  }));

  return wrap ? _react["default"].createElement(_reactstrap.FormGroup, null, body) : body;
}

var _default = _react["default"].forwardRef(InputWithError);

exports["default"] = _default;